import { useWindowDimensions } from "react-native";

// TODO: add other breakpoints as we use them
const RESPONSIVE_BREAKPOINTS = {
  lg: 1024,
} as const;

type Breakpoint = keyof typeof RESPONSIVE_BREAKPOINTS | number;

export default function useMediaQuery() {
  const { width } = useWindowDimensions();

  function parseBreakpoint(w: Breakpoint) {
    if (typeof w === "number") {
      return w;
    } else {
      return RESPONSIVE_BREAKPOINTS[w];
    }
  }

  function greaterThan(w: Breakpoint) {
    return width > parseBreakpoint(w);
  }

  function lesserThan(w: Breakpoint) {
    return width < parseBreakpoint(w);
  }

  return { greaterThan, lesserThan, width };
}
